// Defensive field renderer: clinical records evolve over time and some older
// diagnosis / note rows store list-of-strings or dict values where newer rows
// store flat strings. Rendering a dict as a React child crashes the whole
// page with "Objects are not valid as a React child". This coerces anything
// into a safe, readable string without losing information.
export function renderField(val, opts = {}) {
  const { separator = '\n' } = opts;
  if (val === null || val === undefined) return '';
  if (typeof val === 'string' || typeof val === 'number') return String(val);
  if (Array.isArray(val)) {
    return val.map((v) => {
      if (v === null || v === undefined) return '';
      if (typeof v === 'string' || typeof v === 'number') return `• ${v}`;
      if (typeof v === 'object') {
        // Prefer human keys on list-of-dicts (e.g. interventions)
        const keys = Object.keys(v);
        if (keys.length <= 4) {
          return '• ' + keys.map((k) => `${k}: ${renderField(v[k], { separator: ' ' })}`).join(' · ');
        }
        return '• ' + JSON.stringify(v);
      }
      return `• ${String(v)}`;
    }).filter(Boolean).join(separator);
  }
  if (typeof val === 'object') {
    // Dict: render each key as its own labeled paragraph (biopsychosocial etc)
    return Object.entries(val)
      .map(([k, v]) => {
        const label = k.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
        return `${label}: ${renderField(v, { separator: ' ' })}`;
      })
      .join(separator);
  }
  return String(val);
}
